import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "16", y1: "2", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "8", y1: "2", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "21", y1: "10", y2: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 14h-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13 18H7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 14h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 18h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CalendarRange";
const CalendarRange = memo(themed(Icon));
export {
  CalendarRange
};
//# sourceMappingURL=calendar-range.js.map
